exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".v2 .footer_title[data-v-96b4f07e]{border-bottom:1px solid #ced3e1;padding-bottom:10px;margin:25px 0;line-height:1.5;font-weight:500;font-size:1.8rem!important}.ad-sidebar-more-calc[data-v-96b4f07e]{display:block;padding-top:40px}@media (max-width:991px){.ad-sidebar-more-calc[data-v-96b4f07e]{display:none}}", ""]);

